/**
 * Collection of utilities for interacting with browser APIs since these
 * are only safe in a browser environment
 */

const safeWindow = typeof window !== 'undefined' ? window : null

const safeDocument = safeWindow?.document

export { safeWindow as window, safeDocument as document }

export type Window = typeof window
